import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { ErrorDetails, IContractorEmployeeRequestDto } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';

export class CreateContractorEmployeeCommand extends IRequestCommand<ICreateContractorEmployeeResponse, ErrorDetails, ICreateContractorEmployeeCommandRequest> {
  override _commandType: CommandRequestType = CommandRequestType.POST;

  public setContractorId(id: number) {
    this.urlSections.push('contractorEmployees');
    this.urlSections.push(`${id}`);
    this.composeUrl();
  }
  public setCommandBody(body: ICreateContractorEmployeeCommandRequest): void {
    this._commandBody = body;
  }
}

export interface ICreateContractorEmployeeCommandRequest extends IContractorEmployeeRequestDto, ICommandParameters {

}

export interface ICreateContractorEmployeeResponse extends ICommandResponse {
  id: number;
}
